export default __webpack_public_path__ + "media/miaVid.7f2c1a48.mp4";